import React, { useEffect, useState } from "react";
import ImageUpload from "src/Components/GlobalComponents/ImageUplaod";
import NoItemUI from "src/Components/NoItemUI";
import GradientBtn from "src/Components/WebsiteComponents/GradientBtn";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import moment from "moment";
import InfinteScrollWrapper from "src/Components/GlobalComponents/Widget/InfinteScrollWrapper";
import { useSelector } from "react-redux";
import { RootState } from "src/Store/store";
import qs from "qs";
import CustomCheckBox from "src/Components/GlobalComponents/CustomCheckBox";

const ReportsScreenSection = ({ currentDoctor }: { currentDoctor: any }) => {
  const { userDetails } = useSelector((state: RootState) => state?.appReducer);
  const [reportImage, setReportImage] = useState<any>(null);
  const [reports, setReports] = useState<any[]>([]);
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [selectedReport, setSelectedReport] = useState<string[]>([]);
  const [isShareLoader, setIsShareLoader] = useState<boolean>(false);
  const [getReportLoader, setGetReportLoader] = useState<boolean>(false);
  const [queryParams, setQueryParams] = useState<any>({
    page: 1,
    limit: 10,
    doctorId: currentDoctor?.id,
    customerId: userDetails?._id,
  });
  const [paginated, setPaginated] = useState<any>({
    currentPage: 1,
    totalPages: 1,
  });

  const handleSaveReport = async () => {
    if (!reportImage) {
      toast.error("Please upload a report");
      return;
    }
    let formData = new FormData();
    formData.append("report", reportImage);
    formData.append("doctorId", currentDoctor?.id);

    setIsLoader(true);

    const { res, err } = await httpRequest<any>({
      path: `/appoiment/create-reports`,
      method: "post",
      params: formData,
      header: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (res) {
      toast.success("Report saved successfully");
      setReportImage(null);
      setReports([...reports, res?.data]);
    } else {
      toast.error(err);
    }
    setIsLoader(false);
  };

  const handleGetReports = async (params: any = queryParams) => {
    setGetReportLoader(true);
    const { res, err } = await httpRequest<any>({
      path: `/appoiment/all-Reports?${qs.stringify(params)}`,
      method: "get",
    });
    if (res) {
      setReports(res?.documents);
      setPaginated(res?.paginated);
    } else {
      toast.error(err);
    }
    setGetReportLoader(false);
  };

  const handleChangeQueryParams = (
    d: Partial<typeof queryParams>,
    resetPage: boolean = true
  ) => {
    let newQueryParams = {
      ...queryParams,
      ...d,
    };
    if (resetPage) {
      newQueryParams.page = 1;
      setPaginated((prev: any) => ({
        ...prev,
        currentPage: 1,
      }));
      setReports([]);
    }
    setQueryParams(newQueryParams);
    handleGetReports(newQueryParams);
  };

  const handleShareReport = async () => {
    setIsShareLoader(true);
    const { res, err } = await httpRequest<any>({
      path: `/appoiment/share-reports`,
      method: "post",
      params: {
        reportIds: selectedReport,
      },
    });
    if (res) {
      toast.success("Report shared successfully");
      setReports((prev: any) =>
        prev.filter((report: any) => !selectedReport.includes(report?._id))
      );
      setSelectedReport([]);
    } else {
      toast.error(err);
    }
    setIsShareLoader(false);
  };

  useEffect(() => {
    handleChangeQueryParams({});
  }, []);

  return (
    <>
      <div className="w-full min-h-full flex flex-col gap-2 2xl:gap-3 justify-between">
        <div className="w-full flex flex-col gap-2 2xl:gap-3">
          <div className="w-full bg-white shadow-all-light-2 rounded-lg p-2 2xl:p-3">
            <p className="font-size-15px font-Poppins-Medium mb-1 text-[#2A2A2A]">
              Upload
            </p>
            <ImageUpload
              onImageChange={setReportImage}
              image={reportImage}
              extraClasses="w-full h-[150px]"
              containerClasses="mb-0"
            />
          </div>
          <div className="w-full flex flex-col gap-2 2xl:gap-3">
            <p className="font-size-15px font-Poppins-Medium mb-1 text-[#2A2A2A]">
              Reports
            </p>
            <InfinteScrollWrapper
              isLoading={getReportLoader}
              length={reports?.length}
              currentPage={paginated?.currentPage}
              totalPages={paginated?.totalPages}
              onLoadMore={(page: number) => {
                handleChangeQueryParams({ page }, false);
              }}
              noDataOptions={{
                text: "No reports found",
                text2: "Upload a report to get started",
              }}
            >
              {reports.filter((report) => !report?.isShare).map((report, index) => (
                <div
                  key={index}
                  className={`w-full relative cursor-pointer ${
                    report?.isShare ? "bg-[#f6faff]" : "bg-white"
                  } ${
                    selectedReport.includes(report?._id)
                      ? "border-2 border-theme-color-green"
                      : ""
                  } shadow-all-light-2 rounded-lg p-2 2xl:p-3 flex items-center justify-between gap-2`}
                  onClick={() => {
                    if (selectedReport.includes(report?._id)) {
                      setSelectedReport(
                        selectedReport.filter((id) => id !== report?._id)
                      );
                    } else {
                      setSelectedReport([...selectedReport, report?._id]);
                    }
                  }}
                >
                  <div className="absolute top-3 right-2">
                    <CustomCheckBox
                      checked={selectedReport.includes(report?._id)}
                      onChange={(status) => {
                        if (status) {
                          setSelectedReport([...selectedReport, report?._id]);
                        } else {
                          setSelectedReport(
                            selectedReport.filter((id) => id !== report?._id)
                          );
                        }
                      }}
                    />
                  </div>
                  <img
                    src={report?.report}
                    alt="Report"
                    className="w-[110px] h-[90px] object-cover rounded-lg"
                  />
                  <p className="font-size-16px font-Poppins-Regular whitespace-nowrap text-[#3B3B3B]">
                    {moment(report?.createdAt).format("DD-MM-YYYY")}
                  </p>
                </div>
              ))}
            </InfinteScrollWrapper>
          </div>
        </div>
        <div className="w-full bg-[#f6faff] px-2 2xl:px-3 flex items-center justify-center gap-2">
          {selectedReport.length > 0 && (
            <GradientBtn
              ButtonText="Share"
              onPress={handleShareReport}
              loader={isShareLoader}
              extraClass="min-w-[150px]"
            />
          )}
          {reportImage && (
            <GradientBtn
              ButtonText="Save"
              onPress={handleSaveReport}
              extraClass="min-w-[150px]"
              loader={isLoader}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ReportsScreenSection;
